"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault").default;

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.useCoercion = exports.CoercionContextProvider = void 0;

var _parseFloat2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/parse-float"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/parse-int"));

var _react = _interopRequireDefault(require("react"));

const CoercionContext = /*#__PURE__*/_react.default.createContext({});

const CoercionContextProvider = ({
  children
}) => {
  const [coercions, setCoercions] = _react.default.useState({});

  return /*#__PURE__*/_react.default.createElement(CoercionContext.Provider, {
    value: {
      coercions,
      setCoercions
    }
  }, children);
};

exports.CoercionContextProvider = CoercionContextProvider;

const coercionWarn = (type, value) => {
  if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
    console.warn(`Invalid ${type}. Form field validation not set.  Returning 'undefined' instead of '${value}'`);
  }
};

const COERCION_FUNCTIONS = {
  Boolean: value => !!value,
  Float: value => {
    const val = (0, _parseFloat2.default)(value);

    if (isNaN(val)) {
      coercionWarn('Float', value);
      return undefined;
    }

    return val;
  },
  Int: value => {
    const val = (0, _parseInt2.default)(value, 10);

    if (isNaN(val)) {
      coercionWarn('Int', value);
      return undefined;
    }

    return val;
  },
  Json: value => {
    try {
      return JSON.parse(value);
    } catch (e) {
      coercionWarn('Json', value);
      return undefined;
    }
  },
  DateTime: value => {
    try {
      return new Date(value).toISOString();
    } catch (e) {
      coercionWarn('DateTime', value);
      return undefined;
    }
  }
};
const inputTypeToDataTypeMapping = {
  checkbox: 'Boolean',
  number: 'Int',
  date: 'DateTime',
  'datetime-local': 'DateTime'
};

const useCoercion = () => {
  const coercionContext = _react.default.useContext(CoercionContext);

  const coerce = _react.default.useCallback((name, value) => coercionContext.coercions[name] ? coercionContext.coercions[name](value) : value, [coercionContext.coercions]);

  const setCoercion = _react.default.useCallback(({
    name,
    type,
    transformValue
  }) => {
    let coercionFunction;

    if (typeof transformValue === 'function') {
      coercionFunction = transformValue;
    } else {
      if (transformValue) {
        coercionFunction = COERCION_FUNCTIONS[transformValue];

        if (!coercionFunction && (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test')) {
          console.warn('Form input ' + name + ' does not have a valid transformValue');
        }
      } else if (type && inputTypeToDataTypeMapping[type]) {
        coercionFunction = COERCION_FUNCTIONS[inputTypeToDataTypeMapping[type]];
      } else {
        coercionFunction = value => value;
      }
    }

    coercionContext.setCoercions.call(null, coercions => ({ ...coercions,
      [name]: coercionFunction
    }));
  }, [coercionContext.setCoercions]);

  return {
    coerce,
    setCoercion
  };
};

exports.useCoercion = useCoercion;